import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
import { getPortalId } from '../../common/utils';
import { defineComponent } from '../../platform/models';
import { TRIAL_BANNER_COMPONENT } from '../constants';
import { TRIAL_BANNER_ID } from './constants';
export const trialBannerComponentDef = defineComponent(TRIAL_BANNER_COMPONENT, {
  name: TRIAL_BANNER_COMPONENT,
  path: `/trial-banner/${getPortalId()}/`,
  capabilities: [capabilities.NAVIGATE_TO_CAP.getName(), capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName()],
  deferLoading: true,
  initiallyOpen: false,
  iframeProps: {
    id: 'trial-banner-iframe',
    style: {
      width: '100%',
      height: '50px',
      overflow: 'hidden',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#5E6AB8'
    },
    ['data-test-id']: 'trial-banner-iframe',
    title: 'trial-banner-iframe'
  },
  propsSchema: {
    // Used to determine if the Navigation component iframe should be shown
    hasTrialBanners: args.bool()
  },
  initialProps: {
    hasTrialBanners: false
  },
  renderTo: () => {
    const existingTrialBanner = document.querySelector(`#${TRIAL_BANNER_ID}`);
    if (existingTrialBanner) {
      return existingTrialBanner;
    }
    const navElement = document.getElementById('hs-nav-v4');
    const newTrialBanner = document.createElement('div');
    newTrialBanner.id = TRIAL_BANNER_ID;
    if (navElement && navElement.parentNode) {
      navElement.insertBefore(newTrialBanner, navElement.firstChild);
      navElement.parentNode.removeChild(navElement.parentNode.childNodes[0]);
    }
    return newTrialBanner;
  }
});